import React from "react";

export const BriefCaseIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M28.8144 7.25651H21.9192V4.47805C21.9192 3.15509 20.8429 2.07886 19.5199 2.07886H12.48C11.1571 2.07886 10.0808 3.15509 10.0808 4.47805V7.25651H3.18559C1.42901 7.25651 0 8.68558 0 10.4421V26.7354C0 28.4919 1.42901 29.9209 3.18559 29.9209H28.8144C30.5709 29.9209 32 28.4919 32 26.7354V10.4421C32 8.68558 30.5709 7.25651 28.8144 7.25651ZM12.113 4.47805C12.113 4.27566 12.2776 4.11105 12.48 4.11105H19.5199C19.7223 4.11105 19.887 4.27572 19.887 4.47805V7.25651H12.113V4.47805ZM2.03219 10.4421C2.03219 9.80608 2.54958 9.2887 3.18559 9.2887H28.8144C29.4504 9.2887 29.9678 9.80608 29.9678 10.4421V11.946C29.9678 13.3566 29.0219 14.6171 27.6676 15.0114L17.0402 18.1056C16.3597 18.3038 15.6403 18.3038 14.9597 18.1056L4.33238 15.0114C2.97805 14.617 2.03219 13.3566 2.03219 11.946V10.4421ZM28.8144 27.8888H3.18559C2.54964 27.8888 2.03219 27.3714 2.03219 26.7355V16.0833C2.54424 16.4791 3.12793 16.7773 3.76426 16.9626C15.5039 20.3806 14.9006 20.2865 16 20.2865C17.1139 20.2865 16.4823 20.3846 28.2357 16.9626C28.8721 16.7773 29.4558 16.4791 29.9677 16.0833V26.7354C29.9678 27.3713 29.4504 27.8888 28.8144 27.8888Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
